import { IApplicationState } from '../../types/redux';

export const selectRecentlyViewedOffers = (state: IApplicationState) => state.recentlyViewed.data;

export const selectRecentlyViewedById = (id: number) => (state: IApplicationState) =>
  state.recentlyViewed.data.find(({ offerId }) => offerId === id);
